<!--
 * @Description: 文章顶部banner
 * @Author: Fore-Zhang
 * @Date: 2021-01-12 01:14:40
 * @LastEditTime: 2021-01-13 14:11:08
-->
<template>
  <div id="ArticleTopBanner">
    <img :src="require('../assets/'+path)">
  </div>
</template>

<script>
export default {
  name: "ArticleTopBanner",
  computed:{
    path(){
      switch(this.$route.name){
        case 'Article':
          return this.$route.params.issue+'/'+this.$route.params.id+'/top.jpg';
          break;
        case 'AboutUs':
          return 'aboutme_top_img.jpg';
          break;
      }
    }
  }
}
</script>


<style lang="less" scoped>
@fullWidth:11.25rem;
.fullWidth{
  width: @fullWidth;
}

#ArticleTopBanner{
  .fullWidth();

  img{
    width: 100%;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/ArticleTopBanner.vue